<template>
  <div>
    <el-row>
      <el-card style="margin: auto;">
        <div slot="header" class="clearfix">
          <span style="float:left; font-weight: 800">用户列表</span>
          <el-button style="float:right" size="small" type="text" @click="visible = true">添加新用户</el-button>
        </div>

        <!-- 创建新用户 -->
        <el-dialog :visible.sync="visible" title="添加新用户" width="30%">
          <el-form ref="addForm" :model="addForm" :rules="rules">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="addForm.email" type="email" placeholder="请输入邮箱地址"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="addForm.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="重复密码" prop="passwordconfirm">
              <el-input v-model="addForm.passwordconfirm" type="password" placeholder="请再次输入密码"></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickName">
              <el-input v-model="addForm.nickName" placeholder="请输入昵称"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input v-model="addForm.phoneNumber" placeholder="请输入电话号" type="number"></el-input>
            </el-form-item>
            <el-form-item label="IM">
              <el-input v-model="addForm.im" placeholder="请输入相关IM联系方式"></el-input>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button @click="visible = false" size="small">取消</el-button>
            <el-button  type="primary" @click="create_user" size="small">创建</el-button>
          </template>
        </el-dialog>

        <!-- 用户表格 -->
        <el-table :data="users" border stripe>
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="名称" prop="name"></el-table-column>
          <el-table-column label="邮箱" prop="email"></el-table-column>
          <el-table-column label="昵称" prop="nickName"></el-table-column>
          <el-table-column label="电话" prop="phoneNumber"></el-table-column>
          <el-table-column label="IM" prop="im"></el-table-column>
          <el-table-column label="创建时间" prop="create_at"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="edit_user(scope.row.id)">编辑</el-button>
              <el-button type="danger" size="mini" @click="delete_user(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 15px">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="get_users"></el-pagination>
        </div>

        <!-- 编辑用户 -->
        <el-dialog :visible.sync="edit_visible" :title="this.user.name + '的角色'" width="30%">
          <el-form label-width="80px">
            <el-form-item label="选择角色">
              <el-select multiple :value="mid_roles" placeholder="选择角色" @change="edit_roles" style="display:block">
                <el-option v-for="i in roles" :key="i" :label="i" :value="i"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button size="small" @click="edit_visible = false">取消</el-button>
            <el-button type="primary" size="small" @click="update_user()">修改</el-button>
          </template>
        </el-dialog>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("邮箱地址不能为空"));
      } else {
        setTimeout(() => {
          var pattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
          if (!pattern.test(value)) {
            callback(new Error("请输入正确的邮箱地址"));
          } else {
            callback();
          }
        }, 500);
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.addForm.passwordconfirm !== "") {
          this.$refs.addForm.validateField("passwordconfirm");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.addForm.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      users: [],
      pageSize: 0,
      total: 0,
      visible: false,
      edit_visible: false,
      user: {
        name: "",
        roles: [],
      },
      roles: [],
      mid_roles: [],
      addForm: {
        email: "",
        name: "",
        nickName: "",
        password: "",
        passwordconfirm: "",
        phoneNumber: "",
        im: "",
      },
      rules: {
        email: [
          { required: true, message: "请输入邮件地址", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "change" },
        ],
        passwordconfirm: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "change" },
        ],
        nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
      },
    };
  },
  created() {
    this.pageSize = this.config.pageSize;
    this.get_users(1);
    this.get_roles();
  },
  methods: {
    get_users(page) {
      var _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/users?currentPage=" +
            page +
            "&pageSize=" +
            this.pageSize,
          {
            headers: {
              Authorization: "Bearer " + this.config.getCookie(),
            },
          }
        )
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取用户数据失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.total = response.data.page.totalCount;
            _this.users = response.data.data;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户数据失败: " + error.toString(),
            type: "error",
          });
        });
    },
    get_roles() {
      var _this = this;
      _this.roles = [];
      _this.$axios
        .get(_this.config.path + "/roles?currentPage=0&pageSize=1", {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取角色数据失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.roles = response.data.data;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户数据失败: " + error.toString(),
            type: "error",
          });
        });
    },
    create_user(e) {
      console.log(e);
      const _this = this;
      _this.$refs["addForm"].validate((valid) => {
        if (valid) {
          _this.$axios
            .post(_this.config.path + "/users", _this.addForm, {
              headers: {
                Authorization: "Bearer " + this.config.getCookie(),
              },
            })
            .then(function (response) {
              if (response.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "创建用户失败: " + response.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "创建用户成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (error) {
              _this.$message({
                showClose: true,
                message: "创建用户失败: " + error.toString(),
                type: "error",
              });
            });
        } else {
          _this.$message({
            showClose: true,
            message: "创建用户失败，请填写必要的信息",
            type: "error",
          });
          return false;
        }
      });
      this.visible = false;
    },
    delete_user(id) {
      console.log("delete user id: " + id);
      const _this = this;
      this.$confirm("删除用户后无法还原，确认删除么？", "删除用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          _this.$axios
            .delete(_this.config.path + "/users/" + id, {
              headers: {
                Authorization: "Bearer " + this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "删除用户失败: " + res.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "删除用户成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (err) {
              _this.$message({
                showClose: true,
                message: "删除用户失败: " + err.toString(),
                type: "error",
              });
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    edit_user(id) {
      console.log("edit user:", id);
      this.get_user(id);
      // this.update_user;
    },
    get_user(id) {
      var _this = this;
      console.log("all roles", _this.roles);
      _this.mid_roles = [];
      _this.$axios
        .get(_this.config.path + "/users/" + id, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取用户及角色信息失败: " + res.data.message,
              type: "error",
            });
          } else {
            _this.user = res.data.data;
            _this.mid_roles = _this.user.roles;
            console.log("current user: ", _this.user);
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户及角色信息失败: " + error.toString(),
            type: "error",
          });
        });
      this.edit_visible = true;
    },
    edit_roles(value) {
      this.mid_roles = value;
      console.log('current roles:', this.mid_roles)
    },
    update_user() {
      const _this = this;
      _this.user.roles = _this.mid_roles;
      console.log("user: ", _this.user);
      _this.$axios
        .put(_this.config.path + "/users/" + _this.user.id, _this.user, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (response) {
          if (response.data.success === true) {
            _this.$message({
              showClose: true,
              message: "编辑成功",
              type: "success",
            });
            setTimeout(function () {
              _this.$router.go(0);
            }, 500);
          } else {
            _this.$message({
              showClose: true,
              message: "编辑失败：" + response.data.message,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "编辑失败：" + error.toString(),
            type: "error",
          });
        });
      _this.edit_visible = false;
    },
  },
};
</script>

<style>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
